import React from 'react';
import { Box, Typography } from '@mui/material';
import { YouTubeCarousel } from './YouTubeCarousel';

export function Youtube() {
  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h3" sx={{ color: 'primary.main', fontWeight: 800, letterSpacing: '-0.02em' }}>
          Clip officiel
        </Typography>
      </Box>
      <YouTubeCarousel />
    </Box>
  );
}

export default Youtube;
